import { render } from "./popup-renew-rates.vue?vue&type=template&id=78519c96&ts=true"
import script from "./popup-renew-rates.vue?vue&type=script&lang=ts"
export * from "./popup-renew-rates.vue?vue&type=script&lang=ts"

import "./popup-renew-rates.vue?vue&type=style&index=0&id=78519c96&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__